<template>
  <div class="advanceSearch hideScrollbar">
    <div class='flexV'>
      <div class='main'>
        <div class="title">精准搜索</div>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="4" class="conditionList">
            选择搜索文库
          </el-col>
          <el-col :xs="15" :sm="20" class="conditionList">
            <el-radio-group v-model="library">
              <el-radio label="standards" size="20">
                <span>标准库</span>
              </el-radio>
              <el-radio label="regulations" size="20">
                <span>法规库</span>
              </el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="4" class="conditionList">
            包含以下关键字
          </el-col>
          <el-col :xs="15" :sm="20" class="conditionList">
            <input type="text" class="conditionInput" v-model="keywords_main" placeholder="必填，多关键字之间用空格">
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="4" class="conditionList">
            标准或法规名称
          </el-col>
          <el-col :xs="15" :sm="20" class="conditionList">
            <input type="text" class="conditionInput" v-model="keywords_title" placeholder="选填">
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="4" class="conditionList">
            标准或法规编号
          </el-col>
          <el-col :xs="15" :sm="20" class="conditionList">
            <input type="text" class="conditionInput" v-model="keywords_num" placeholder="选填">
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="4" class="conditionList">
            发布机构
          </el-col>
          <el-col :xs="15" :sm="20" class="conditionList">
            <input type="text" class="conditionInput" v-model="keywords_org" placeholder="选填">
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="4" class="conditionList">
            发布年限
          </el-col>
          <el-col :xs="15" :sm="20" class="conditionList">
            <input type="text" class="conditionInput" v-model="keywords_year" placeholder="选填">
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="9" :sm="4" class="conditionList">
            对应行业
          </el-col>
          <el-col :xs="15" :sm="20" class="conditionList">
            <input type="text" class="conditionInput" v-model="keywords_industry" placeholder="选填">
          </el-col>
        </el-row>
        <div class="searchButton">
          <button class='button' @click="search()">
            精准搜索
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        keywords_main: "",
        keywords_exclude: "",
        keywords_title: "",
        keywords_num: "",
        keywords_org: "",
        keywords_year: "",
        keywords_industry: '',
        library: 'standards'
      }
    },
    methods: {
      search() {
        if (
          this.keywords_main &&
          this.keywords_main.replace(/\s*/g, "").length > 1
        ) {
          if (this.library == 'standards') {
            const {
              href
            } = this.$router.resolve({
              path: "/searchStandardsContents",
              query: {
                keywords: 'c:' + this.keywords_main + " " + ', x:' + this.keywords_title + " " + this.keywords_num +
                  " " + this.keywords_org + " " + this.keywords_year + " " + this.keywords_industry + " "
              }
            });
            window.open(href, "_blank");
          }
          if (this.library == 'regulations') {
            const {
              href
            } = this.$router.resolve({
              path: "/searchRegulationsContents",
              query: {
                keywords: 'c:' + this.keywords_main + " " + ', x:' + this.keywords_title + " " + this.keywords_num +
                  " " + this.keywords_org + " " + this.keywords_year + " " + this.keywords_industry + " "
              }
            });
            window.open(href, "_blank");
          }
        } else {
          alert("您未输入主关键字，或输入的主关键字太短");
        }
      }
    }
  }
</script>

<style scoped>
  .advanceSearch {
    width: 100%;
    height: calc(100vh - 0.5rem);
  }

  .advanceSearch .flexV {
    width: 100%;
    height: 100%;
    padding: 0.01rem;
    /*垂直居中*/
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    justify-content: center;
  }

  .advanceSearch .main {
    width: 100%;
    max-width: 6rem;
    /* 水平居中 */
    margin: 0 auto;
  }

  .advanceSearch .title {
    text-align: center;
    font-size: 0.25rem;
    letter-spacing: 0.03rem;
    font-weight: 700;
    margin: 0.2rem 0
  }

  .advanceSearch .conditionList {
    height: 0.5rem;
    line-height: 0.5rem;
    text-align: left
  }

  .advanceSearch .conditionInput {
    background-color: transparent;
    height: 0.4rem;
    width: 100%;
    border-left-width: 0;
    border-top-width: 0;
    border-right-width: 0;
    border-bottom-width: 0.01rem;
    border-bottom-color: #999;
    outline: none;
    padding-left: 0.1rem;
    text-align: left;
    text-decoration: none;
    letter-spacing: 0.01rem;
  }

  .advanceSearch .searchButton {
    text-align: center;
    width: calc(100% - 0.4rem);
    margin: 0.2rem auto;
  }

  .advanceSearch .button {
    background-color: #aa0000 !important;
    border: solid 0.01rem #efefef;
    border-radius: 0.25rem;
    color: #efefef;
    outline: none;
    text-align: center;
    text-decoration: none;
    letter-spacing: 0.01rem;
    display: inline-block;
    margin-top: 0.3rem;
    width: 1.8rem;
    height: 0.5rem;
  }

  .advanceSearch .button:hover {
    cursor: pointer;
    background-color: red !important;
  }
</style>

<style>
  .advanceSearch .el-radio,
  .advanceSearch .el-radio--medium.is-bordered .el-radio__label {
    font-size: 0.15rem !important
  }

  .advanceSearch .el-radio.is-bordered.is-checked {
    border-color: #aa0000 !important
  }

  .advanceSearch .el-radio--medium.is-bordered .el-radio__inner {
    height: 0.15rem !important;
    width: 0.15rem !important
  }


  .advanceSearch .el-radio__input.is-checked .el-radio__inner {
    border-color: #aa0000 !important;
    background: #aa0000 !important
  }

  .advanceSearch .el-radio__input.is-checked+.el-radio__label {
    color: #aa0000 !important
  }

  .advanceSearch .el-radio__input.is-focus .el-radio__inner {
    border-color: #aa0000 !important
  }

  .advanceSearch .el-radio__inner {
    border: 0.01rem solid #dcdfe6;
    border-radius: 100%;
    width: 0.15rem !important;
    height: 0.15rem !important;
    background-color: #fff;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
  }

  .advanceSearch .el-radio__inner:hover {
    border-color: #aa0000 !important
  }

  .advanceSearch .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    -webkit-box-shadow: 0 0 0.02rem 0.02rem #aa0000 !important;
    box-shadow: 0 0 0.02rem 0.02rem #aa0000 !important
  }
</style>